import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from '../../../constents/axios';
import { toast } from 'react-toastify';

const extractYouTubeID = (url) => {
  try {
    const ytURL = new URL(url);

    if (ytURL.searchParams.has('v')) {
      return ytURL.searchParams.get('v');
    }

    const pathSegments = ytURL.pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];

    if (lastSegment && lastSegment.length >= 6) {
      return lastSegment;
    }

    return '';
  } catch {
    return '';
  }
};




const AddVideos = ({ show, handleClose, initialData = {}, onSubmit }) => {
const [loading, setLoading] = useState(false); 
  const [formData, setFormData] = useState({
    title: '',
    subject: '',
    playlist: '',
    url: '',
    yt_id: '',
  });

  const [subjects, setSubjects] = useState([]);

  useEffect(() => {
    if (show) {
      if (initialData && Object.keys(initialData).length > 0) {
        setFormData({
          title: initialData.title || '',
          subject: initialData.subject || '',
          playlist: initialData.playlist || '',
          url: initialData.url || '',
          yt_id: initialData.yt_id || '',
          id: initialData.id || '',
        });
      } else {
        setFormData({
          title: '',
          subject: '',
          playlist: '',
          url: '',
          yt_id: '',
        });
      }
    }
  }, [show, initialData?.id]);

  useEffect(() => {
    axios
      .get('/api/get-subjects')
      .then((response) => {
        setSubjects(response.data);
      })
      .catch((error) => {
        console.error('Error fetching subjects:', error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'url') {
      const youtubeId = extractYouTubeID(value);
      setFormData((prev) => ({
        ...prev,
        url: value,
        yt_id: youtubeId || '',
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

const handleFormSubmit = async () => {
  try {
    if (!formData.title || !formData.subject || !formData.url) {
      alert('Please fill in all required fields');
      return;
    }

    setLoading(true);

    if (!initialData?.id) {
      const response = await axios.post('/api/add-Freevideos', {
        title: formData.title,
        subject: formData.subject,
        playlist: formData.playlist,
        url: formData.url,
        yt_id: formData.yt_id,
      });

      const newVideo = response.data?.data; 

      toast.success('Video added successfully!', {
        position: 'top-right',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      onSubmit(newVideo);
      setTimeout(() => {
        handleClose();
      }, 1500);
    }
  } catch (error) {
    console.error('Failed to submit form:', error);
    toast.error('Failed to add video. Please try again.');
  } finally {
    setLoading(false);
  }
};

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{initialData?.id ? 'Edit Video' : 'Add Video'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter title"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Subject</Form.Label>
            <Form.Select
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            >
              <option value="">Select Subject</option>
              {subjects.map((subject, idx) => (
                <option key={idx} value={subject}>
                  {subject}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Video Link</Form.Label>
            <Form.Control
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="Enter video URL"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>YouTube ID (Auto Extracted)</Form.Label>
            <Form.Control
              type="text"
              name="yt_id"
              value={formData.yt_id}
              placeholder="Auto-filled from URL"
              disabled
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
       <Button variant="primary" onClick={handleFormSubmit} disabled={loading}>
  {loading ? 'Saving...' : 'Save'}
</Button>

      </Modal.Footer>
    </Modal>
  );
};

export default AddVideos;
